export const EMAIL = "Lancer@heartlandphysics.com";
// Professional portrait of Lancer Smith (supplied by client)
export const PORTRAIT_URL = "/headshot.png";
export const BLUEPRINT_URL =
  "https://images.unsplash.com/photo-1721244654392-9c912a6eb236?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxhcmNoaXRlY3R1cmFsJTIwYmx1ZXByaW50c3xlbnwwfHx8fDE3ODkzNTU4NDN8MA&ixlib=rb-4.1.0&q=85";
export const CT_ROOM_URL =
  "https://images.unsplash.com/photo-1666214280352-db292c05fd80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxob3NwaXRhbCUyMHgtcmF5JTIwbWFjaGluZXxlbnwwfHx8fDE3ODkzNTU4NDN8MA&ixlib=rb-4.1.0&q=85";
export const CLINIC_URL = "/xray-room.jpg";
